module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-A"
  }, [_c('div', {
    staticClass: "headBar linkRoutes"
  }, [_c('span', [_vm._v("出版连续型电子出版物单位审核")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.querys.pressName))])]), _vm._v(" "), (_vm.opMsg) ? _c('div', {
    staticClass: "rejects"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v(_vm._s(_vm.opMsg))])])]) : _vm._e(), _vm._v(" "), (_vm.wSat == 1) ? _c('MainTabs', {
    ref: "mainTab",
    attrs: {
      "bookName": _vm.bookName,
      "pressDat": _vm.resDat,
      "role": "show"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "width": "320",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "label": "审核意见",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pubNumber",
      "width": "120",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "180",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "radioBx",
    staticStyle: {
      "padding": "10px 30px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '21'
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '13'
    }
  }, [_vm._v("注销或拟注销")])], 1), _vm._v(" "), (
    _vm.params.status == '1' ||
    _vm.params.status == '3' ||
    _vm.params.status == '21' ||
    _vm.params.status == '12' ||
    _vm.params.status == '13'
  ) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请填写意见"
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.goBackExamsave
    }
  }, [_vm._v("退回")]) : _vm._e(), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.goExamsave
    }
  }, [_vm._v("提交审核意见")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v("退回")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("审核历史")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar",
    staticStyle: {
      "height": "auto",
      "line-height": "20px",
      "margin-bottom": "10px",
      "padding-bottom": "10px",
      "background-color": "#fff"
    }
  }, [_c('span', [_c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("1.因出版单位在系统填写中存在问题，需退回出版单位修正的，按“退回”键。")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("2.审核意见提交（3选1）"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ① 通过"), _c('br')]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ② 暂缓登记（暂不具备年检通过条件，但仍继续办社的，选此项）"), _c('br')]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ③ 注销或拟注销（暂不具备办社基本条件且已经主办单位同意进行注销的，选此项）"), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7974ee2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/provinceRole/successivePgress/successiveTabs.vue
// module id = 1790
// module chunks = 1